<template>

  <el-row v-loading="loading">
    <div class="line"></div>
    <el-row>
      <el-col :span="1"></el-col>
      <el-col
        :span="3"
        @click.native="callParentSelectFundOrCompany"
        class="ranking-search-return ranking-search-return-font-color"
      >&lt; 返回上一级 </el-col>
      <el-col
        :span="16"
        class="left_text_align ranking-search-return"
      >
        <span v-html="searchTitle"></span>&nbsp;
      </el-col>
    </el-row>
    <div class="line"></div>
    <br>
    <el-table
      :data="tableData"
      border
      @sort-change="sortChange"
      :default-sort="{ prop: 'PriceDate', order: 'descending' }"
      style="width: 100%;"
      class="tableSpecial margin-left-50-important padding-right-50-important"
    >

      <el-table-column
        fixed
        sortable="custom"
        prop="defaultSymbol"
        label="基金代码"
        width="110"
        :render-header="renderheaderRefreshData"    
      >
      </el-table-column>
      <el-table-column
        fixed
        sortable="custom"
        prop="legalName"
        label="基金名称"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        sortable="categoryName"
        prop="categoryName"
        label="基金类型"
        min-width="250"
      >
          <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.categoryName)"></span>                                
            <el-tooltip v-if="scope.row.categoryNoRanking" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
              <div slot="content">{{showTooltipContent(scope.row.returnYTD,showNoRankingIcon,scope.row.returnYTDRankNavOutlier,scope.row.returnYTDRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
            </el-tooltip>
          </template>
      </el-table-column>
      <el-table-column
        prop="inceptionDate"
        label="成立日期"
        min-width="120"
        sortable="custom"
      >
        <template slot-scope="scope">{{ scope.row.inceptionDate | replaceTime }}</template>
      </el-table-column>

     <el-table-column
        label=""
        align="center"              
      >
            <template slot="header">
              <span>晨星评级({{ratingDate}})</span>
            </template>

           <el-table-column
            prop="starRating3"
            label="三年评级"
            min-width="120"
            sortable="custom"            
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating3)">{{ scope.row.starRating3 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating3)"
                :src="getStarRating(scope.row.starRating3)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="starRating5"
            label="五年评级"
            min-width="120"
            sortable="custom"            
            align="center"
            style="background-color:red !important;"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating5)">{{ scope.row.starRating5 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating5)"
                :src="getStarRating(scope.row.starRating5)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="starRating10"
            label="十年评级"
            min-width="120"
            sortable="custom"            
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating10)">{{ scope.row.starRating10 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating10)"
                :src="getStarRating(scope.row.starRating10)"
              />
            </template>
          </el-table-column>
      </el-table-column>
      <el-table-column
        prop="priceDate"
        label="净值日期"
        min-width="120"
        sortable="custom"        
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.priceDate | replaceTime }}</template>
      </el-table-column>
      <el-table-column
        prop="nav"
        label="单位净值|(元)"
        min-width="120"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">          
          <span>{{ scope.row.nav | fillNullRound(4) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="returnYTD"
        label="今年以来|总回报率"
        min-width="120"
        sortable="custom"
        align="center"
        :render-header="renderheader2Row"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.returnYTD | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnYTD)">%</span>
        </template>
      </el-table-column>     

      <el-table-column
        prop="return1Week"
        label="最近一周|总回报率"
        min-width="120"
        sortable="custom"
        align="center"
        :render-header="renderheader2Row"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Week | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Week)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return1Month"
        label="最近一月|总回报率"
        min-width="120"
        sortable="custom"
        align="center"
        :render-header="renderheader2Row"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Month)">%</span>
        </template>
      </el-table-column>      

      <el-table-column
        prop="return3Month"
        label="最近三月|总回报率"
        min-width="120"
        sortable="custom"
        align="center"
        :render-header="renderheader2Row"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return3Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Month)">%</span>
        </template>
      </el-table-column>       

      <el-table-column
        prop="return6Month"
        label="最近六月|总回报率"
        min-width="120"
        sortable="custom"
        align="center"
        :render-header="renderheader2Row"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return6Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return6Month)">%</span>
        </template>
      </el-table-column>
     
      <el-table-column
        label="最近一年"
        align="center"
      >
        <el-table-column
          prop="return1Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return1Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return1YearRank"
          label="同类排名"
          min-width="120"
          align="center"
        >
              <template slot-scope="scope">
                <span v-html="rankTooltip(scope.row.return1YearRank)"></span>                                
                <el-tooltip v-if="showNavOutlier(scope.row.return1Year,scope.row.categoryNoRanking,scope.row.return1YearRankNavOutlier,scope.row.return1YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return1Year,scope.row.categoryNoRanking,scope.row.return1YearRankNavOutlier,scope.row.return1YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近两年"
        align="center"
      >
        <el-table-column
          prop="return2Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return2Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn2Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn2Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return2YearRank"
          label="同类排名"
          min-width="120"
          align="center"
        >
              <template slot-scope="scope">
                <span v-html="rankTooltip(scope.row.return2YearRank)"></span>                                
                <el-tooltip v-if="showNavOutlier(scope.row.return2Year,scope.row.categoryNoRanking,scope.row.return2YearRankNavOutlier,scope.row.return2YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return2Year,scope.row.categoryNoRanking,scope.row.return2YearRankNavOutlier,scope.row.return2YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近三年"
        align="center"
      >
        <el-table-column
          prop="return3Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn3Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn3Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return3YearRank"
          label="同类排名"
          min-width="120"
          align="center"
        >
              <template slot-scope="scope">
                <span v-html="rankTooltip(scope.row.return3YearRank)"></span>                                
                <el-tooltip v-if="showNavOutlier(scope.row.return3Year,scope.row.categoryNoRanking,scope.row.return3YearRankNavOutlier,scope.row.return3YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return3Year,scope.row.categoryNoRanking,scope.row.return3YearRankNavOutlier,scope.row.return3YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近五年"
        align="center"
      >
        <el-table-column
          prop="return5Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return5Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn5Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn5Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return5YearRank"
          label="同类排名"
          min-width="120"
          align="center"
        >
              <template slot-scope="scope">
                <span v-html="rankTooltip(scope.row.return5YearRank)"></span>                                
                <el-tooltip v-if="showNavOutlier(scope.row.return5Year,scope.row.categoryNoRanking,scope.row.return5YearRankNavOutlier,scope.row.return5YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return5Year,scope.row.categoryNoRanking,scope.row.return5YearRankNavOutlier,scope.row.return5YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近七年"
        align="center"
      >
        <el-table-column
          prop="return7Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return7Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn7Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn7Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return7YearRank"
          label="同类排名"
          min-width="120"
          align="center"
        >
              <template slot-scope="scope">
                <span v-html="rankTooltip(scope.row.return7YearRank)"></span>                                
                <el-tooltip v-if="showNavOutlier(scope.row.return7Year,scope.row.categoryNoRanking,scope.row.return7YearRankNavOutlier,scope.row.return7YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return7Year,scope.row.categoryNoRanking,scope.row.return7YearRankNavOutlier,scope.row.return7YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近十年"
        align="center"
      >
        <el-table-column
          prop="return10Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return10Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn10Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn10Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return10YearRank"
          label="同类排名"
          min-width="120"
          align="center"
        >
              <template slot-scope="scope">
                <span v-html="rankTooltip(scope.row.return10YearRank)"></span>                                
                <el-tooltip v-if="showNavOutlier(scope.row.return10Year,scope.row.categoryNoRanking,scope.row.return10YearRankNavOutlier,scope.row.return10YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return10Year,scope.row.categoryNoRanking,scope.row.return10YearRankNavOutlier,scope.row.return10YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近十五年"
        align="center"
      >
        <el-table-column
          prop="return15Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return15Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn15Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn15Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return15YearRank"
          label="同类排名"
          min-width="120"
          align="center"
        >
              <template slot-scope="scope">
                <span v-html="rankTooltip(scope.row.return15YearRank)"></span>                                
                <el-tooltip v-if="showNavOutlier(scope.row.accReturn15Year,scope.row.categoryNoRanking,scope.row.return15YearRankNavOutlier,scope.row.return15YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.accReturn15Year,scope.row.categoryNoRanking,scope.row.return15YearRankNavOutlier,scope.row.return15YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="returnInception"
        label="成立以来|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.returnInception | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnInception)">%</span>
        </template>
      </el-table-column>
    </el-table>
    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
        class="margin-left-50-important"
      >
      </el-pagination>
    </el-col>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import { getFundCache, getFundRank } from "../api/ranking";
import { loadingData } from "./mixin/loadingData";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const removeNameAndValue=componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const formatDecimal=componentsCommon.apiCommon.formatDecimal;
const dateWithForwardSlash=componentsCommon.apiCommon.dateWithForwardSlash;

export default {
    mixins: [loadingData],
    data() {
        return {
            searchTitle: "",
            isShowRankingTab: true,
            dialogLoading: false,
            loading: false,
            tableData: [],
            pageSize: 0,
            selectFormat: "xlsx",
            ratingDate:'',
            pagination: {
                skip: 0,
                limit: 10,
                count: 0,
            },
            params: {
                type: "",
                category: "", //"EquityFunds",
                keyword: "",
                date: "", //"2020-06-30",
                month: "", //"2020-06-30",
                quarter: "", //"2020-06-30",
                sort: "PriceDate",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1,
            }
        };
    },
    watch: {},
    filters: {
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        fillNullRound(value, fixedDecimal) {
            if (value != undefined && value != null && value != "") {
                return formatDecimal(value, fixedDecimal);
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return dateWithForwardSlash(value);
            } else {
                return "--";
            }
        },
    },
    mounted() {
        /*const self = this;
        self.getData(self.params);*/
    },
    methods: {
        callParentSelectFundOrCompany() {
            this.$parent.$parent.selectFundOrCompany("");
        },
        showUnidentifiedData() {
            let unidentifiedList = getNameAndValue("unidentifiedList");
            unidentifiedList = JSON.parse(unidentifiedList);
            const blob = new Blob(["\ufeff" + unidentifiedList.join("\n")], {
                type: "text/csv;charset=utf-8",
            });
            createLinkForDownload(blob, "unidentifiedList.csv");
        },
        loadingData(
            category,
            keyword,
            effectiveDate,
            isShowRankingTab,
            symbolInfo
        ) {
            const self = this;
            self.searchTitle = "";
            if (keyword != null && keyword != "") {
                self.params.keyword = keyword;
                self.params.category = "";
                self.activeName = "";
                self.activeNameEqutity = "";
                self.searchTitle = "基金公司：<b>" + keyword + "</b>";
            } else {
                self.params.keyword = "";
            }
            if (symbolInfo && symbolInfo != "undefined_undefined") {
                if (symbolInfo.indexOf("_") > -1) {
                    self.params.keyword = symbolInfo.split("_")[0];
                    self.searchTitle =
                        "基金名称：<b>" + symbolInfo.split("_")[1] + "</b>";
                } else {
                    self.params.keyword = symbolInfo;
                    self.searchTitle = "";
                }
                self.params.type = "";
                self.params.category = "";
                self.activeName = "";
                self.activeNameEqutity = "";
            }
            if (effectiveDate != null && effectiveDate != "") {
                self.params.date = effectiveDate;
            } else {
                self.params.date = "";
            }
            /*self.params.month=effectiveDate;
            self.params.quarter=effectiveDate;*/
            self.getData(self.params);
        },
    },
};
</script>
<style lang="scss">
@import "../../public/sass/components/ranking";
</style>
<style scoped>
/*给table了列添加左边的border begin*/
.tableSpecial >>> table tr:nth-child(1) th {
    line-height: 35px;
    border-top: 1px solid #ebeef5 !important;
}

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(2),
.tableSpecial >>> table tr td:nth-last-child(1),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(3),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(4),
.tableSpecial >>> table tr td:nth-last-child(4),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(4),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(7),
.tableSpecial >>> table tr td:nth-last-child(7),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(5),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(10),
.tableSpecial >>> table tr td:nth-last-child(10),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(6),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(13),
.tableSpecial >>> table tr td:nth-last-child(13),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(7),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(16),
.tableSpecial >>> table tr td:nth-last-child(16),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(8),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(19),
.tableSpecial >>> table tr td:nth-last-child(19),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(9),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(21),
.tableSpecial >>> table tr td:nth-last-child(21),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(10),
.tableSpecial >>> table tr td:nth-last-child(22),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(11),
.tableSpecial >>> table tr td:nth-last-child(23),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(12),
.tableSpecial >>> table tr td:nth-last-child(24),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(13),
.tableSpecial >>> table tr td:nth-last-child(25),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(14),
.tableSpecial >>> table tr td:nth-last-child(26),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(16),
.tableSpecial >>> table tr td:nth-last-child(28),

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(17),
.tableSpecial >>> table tr:nth-child(2) th:nth-last-child(24),
.tableSpecial >>> table tr td:nth-last-child(31) {
    border-left: 1px solid #ebeef5 !important;
}
/*给table了列添加左边的border end*/
</style>

